import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5278d93d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Element hinzufügen", -1))
const _hoisted_3 = { class: "search" }
const _hoisted_4 = { class: "list-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_button = _resolveComponent("md-button")!
  const _component_md_tooltip = _resolveComponent("md-tooltip")!
  const _component_md_input_field = _resolveComponent("md-input-field")!
  const _component_flow_steps_list = _resolveComponent("flow-steps-list")!
  const _component_md_card = _resolveComponent("md-card")!

  return (_openBlock(), _createBlock(_component_md_card, {
    variant: "elevated",
    class: "block-elements"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["elements-header", { scroll: _ctx.scroll }])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createVNode(_component_md_tooltip, {
            position: "left",
            text: "Schließen"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_md_button, {
                variant: "icon",
                icon: "close",
                grey: "",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_md_input_field, {
            label: "Suchbegriff",
            modelValue: _ctx.query,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.query) = $event)),
            variant: "outlined",
            "trailing-icon": "search",
            error: false,
            size: "small"
          }, null, 8, ["modelValue"])
        ])
      ], 2),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_flow_steps_list, {
          items: _ctx.elements,
          query: _ctx.query,
          draggable: false,
          onScroll: _ctx.onScroll,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('click', $event)))
        }, null, 8, ["items", "query", "onScroll"])
      ])
    ]),
    _: 1
  }))
}